import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DISCORD_URL, EMAIL_SALES } from '@app/config';
import { FaqAccordionComponent, SectionHeaderComponent } from '@app/widgets';
import { ENTERPRISE_FAQS } from '../../constants';

@Component({
  selector: 'app-enterprise-faq-section',
  imports: [SectionHeaderComponent, FaqAccordionComponent],
  templateUrl: './enterprise-faq-section.component.html',
  styleUrl: './enterprise-faq-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnterpriseFaqSectionComponent {
  protected readonly discordUrl = DISCORD_URL;
  protected readonly emailSales = EMAIL_SALES;
  protected readonly items = ENTERPRISE_FAQS;
}
